import { useEffect } from "react"
import { useCompany } from "../context/CompanyContext.tsx"

/** Sets the browser tab title via company branding context. */
export function usePageTitle(pageName: string) {
  const { setPageTitle } = useCompany()
  useEffect(() => {
    setPageTitle(pageName)
  }, [pageName, setPageTitle])
}
